export default __webpack_public_path__ + "static/media/img-1.dd1e357e.jpg";